import { VText } from '@vake/ui-kit';
import { FC } from 'react';
import styled from 'styled-components';
import Analysing from '../../../shared/components/Analysing';
import constants from '../../../shared/constants';

const ColumnWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    margin: 200px auto;
    max-width: 650px;
    margin-left: 20px;
    @media screen and (max-width: ${constants.breakpoints.mobile}) {
        width: 100%;
        margin: 0;
        margin-bottom: 80px;
    }
`;
const Intro: FC = () => {
    return (
        <div className="flex mx-auto max-w-[1255px] w-screen min-h-[850px]">
            <ColumnWrapper>
                <div>
                    <div className="max-[600px]:bg-[url('/images/SatelliteMobile.png')] max-[600px]:bg-[length:100%] max-[600px]:h-[153vw]">
                        <div>
                            <VText variant="Di1">Processing oceans for you</VText>
                            <div style={{ display: 'flex' }}>
                                <Analysing />
                            </div>
                        </div>
                    </div>
                    <div>
                        <VText>
                            Total Maritime Domain Awareness is a combined effort. We do our part by processing
                            multispectral satellite images with cutting edge machine learning. Our ship detections
                            provides a focal point for your maritime operations – wherever you are.
                        </VText>
                    </div>
                </div>
            </ColumnWrapper>
        </div>
    );
};

export default Intro;
